
import {Vue, Watch, Component, Prop} from 'vue-property-decorator';
import {  readUserPromocodesList } from '@/store/main/getters';
import { dispatchActionCreateUserPromocode, dispatchActionValidateDexIdPromocode} from '@/store/main/actions'
// import GeneratePrivateKeyDexIdModal from "@/components/Main/Transactions/GeneratePrivateKeyDexIdModal.vue";

interface IPromoCode {
  dexid_promocode: string;
  enabled: boolean,
  dexid_promocode_type: string,
  service_type: string,
  comment: string,
  count_used: number,
  bonuses_by_currency: any
}
@Component({
  components: {}
})
export default class GeneratePrivateKeyModal extends Vue {
  // @ts-ignore
  @Prop({ required: true, default: false }) public readonly modalShow: boolean;
  public isModalClosed: boolean = false;
  public code: string = "";
  public isError: boolean = false;
  public errorMessage: string = "";
  public isTestCode: boolean = false;
  public isCheckCodeLoading: boolean = false;
  public isLoadingCreate: boolean = false;

  get promoCodeList() {
    return readUserPromocodesList(this.$store);
  }

  // public async mounted() {}

  public closeModal(isCreated: boolean) {
    this.isModalClosed = true;
    this.$emit("close-modal", isCreated);
  }

  // Быстрая проверка длины без debounce
  @Watch('code')
  onCodeChange(newValue: string): void {
    if(newValue.length < 4) {
      this.errorMessage = "The promo code must contain more than 3 characters";
      this.isError = true;
    } else {
      this.isError = false;
      this.errorMessage = "";
    }
  }

  public async validateKey(): Promise<boolean | void> {
    if(this.code.length < 4) return;

    if(this.isTestCode) return;
    // Ожидаем завершения текущей валидации, если она уже идёт
    if(this.isCheckCodeLoading) {
      return new Promise<boolean>((resolve) => {
        const interval = setInterval(() => {
          if(!this.isCheckCodeLoading) {
            clearInterval(interval);
            resolve(!this.isError);
          }
        }, 50);
      });
    }
    
    
    this.isTestCode = true;
    this.isCheckCodeLoading = true;
    try {
      const payload = {
        code: this.code
      }
     const response = await dispatchActionValidateDexIdPromocode(this.$store, payload)
      // console.log('response ',response)
      this.isTestCode = false;
      this.isError = false;
      this.errorMessage = "";
      this.isCheckCodeLoading = false;
      
      this.$toast.success(this.$t('A promo code can be created').toString());
      return true;
    } catch (error) {
      if(error?.response?.status === 400){
        this.$toast.error("This promo code already exists, please enter another one.");
        this.isError = true;
        this.isTestCode = false;
        return false;
      } 
    
      this.$toast.error("Check the correctness of filling");
      this.isError = true
      this.isTestCode = false
      return false;
    } finally {
      this.isCheckCodeLoading = false;
      this.isTestCode = false;
    }
    
    /**
     * const exists = this.promoCodeList.find(
      (el: IPromoCode) => el.dexid_promocode === this.code
    );

    if(!exists) {
      // this.$toast.success(this.$t('A promo code can be created').toString());
      this.isTestCode = false;
      return true;
    } else {
      this.$toast.error("This promo code already exists, please enter another one.");
      this.isError = true;
      this.isTestCode = false;
      return false;
    }
     */
  
    /* old 
    const invoiceResp = await dispAuthFetch(this.$store, {
      input: "/api/v1/dexnet_integration/validate-dexid-promocode/",
      init: {
        method: "POST",
        body: {
          code: this.code,
        },
      },
    });

    if (invoiceResp && invoiceResp.status === 200) {
      this.$toast.success(this.$t('A promo code can be created').toString());
      this.isTestCode = false
      return true;
    } else if (invoiceResp && invoiceResp.status === 400) {
      this.$toast.error("Check the correctness of filling");
      this.isError = true
      this.isTestCode = false
      return false;
    }
      */
  }

  public async createPersonalizedKey() {
    if (!(await this.validateKey())) return;

    this.isLoadingCreate = true
    try {
      const payload = {
        code: this.code,
        comment: null,
        service_type: null
      }
      await dispatchActionCreateUserPromocode(this.$store, payload)
      this.$toast.success(this.$t("Promo code created successfully").toString());
      this.closeModal(true)
    } catch (error) {
       this.$toast.error("Failed to create invoice, please try again later");
      
    } finally {
       this.isLoadingCreate = false
    }
  /*
    const invoiceResp = await dispAuthFetch(this.$store, {
      input: "/api/v1/dexnet_integration/create-dexid-promocode/",
      init: {
        method: "POST",
        body: {
          "code": this.code
        },
      },
    });

    if (invoiceResp && invoiceResp.status === 200) {
      this.$toast.success(this.$t('Promo code activated successfully').toString());
      this.closeModal(true)
    } else if (invoiceResp && invoiceResp.status === 400) {
      this.$toast.error("Check the correctness of filling");
    }
      */
  }
}
